import { render, staticRenderFns } from "./primaryButton.vue?vue&type=template&id=fa532cf8&"
import script from "./primaryButton.vue?vue&type=script&lang=ts&"
export * from "./primaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./primaryButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBadge,VCard,VChip,VSheet})
